import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";

import { Country, State, City } from "country-state-city";

import ThemeSettings from "../Property pages/commun/ThemeSettings"
import { AgentHeader } from "./Commun/AgentHeader"
import AgentSidebar from "./Commun/AgentSidebar"
// import { agentsaveComment, agentsaveCompanydetail, agentsaveGuestdetail } from "../Services/Service"


export const AddGuestdetails = () => {
    const navigate = useNavigate();
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const handleCountryChange = (e) => {
        const countryCode = e.target.value;
        setSelectedCountry(countryCode);
        setGuestDetails({ ...guestDetails, Country: countryCode });

        const countryStates = State.getStatesOfCountry(countryCode);
        setStates(countryStates);
        setSelectedState("");
        setCities([]);
        setGuestDetails({ ...guestDetails, Country: countryCode, State: "", City: "" });
    };

    const handleStateChange = (e) => {
        const stateCode = e.target.value;
        setSelectedState(stateCode);
        const stateCities = City.getCitiesOfState(selectedCountry, stateCode);
        setCities(stateCities);
        setGuestDetails({ ...guestDetails, State: stateCode, City: "" });
    };

    const handleCityChange = (e) => {
        setGuestDetails({ ...guestDetails, City: e.target.value });
    };

    const [guestDetails, setGuestDetails] = useState({
        Title: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        EmailAddress: "",
        Address: "",
        MobileNumber: "",
        Country: "",
        State: "",
        City: ""
    });

    const [companyDetails, setCompanyDetails] = useState({
        RegistrationCompanyName: "",
        RegistrationCompanyAddress: "",
        RegistrationNumber: ""
    });

    const [bookingComment, setBookingComment] = useState("");


    const handleGuestChange = (e) => {
        const { name, value } = e.target;
        setGuestDetails({ ...guestDetails, [name]: value });
    };

    const handleCompanyChange = (e) => {
        const { name, value } = e.target;
        setCompanyDetails({ ...companyDetails, [name]: value });
    };

    const handleBookingCommentChange = (e) => {
        setBookingComment(e.target.value);
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        localStorage.setItem("guestDetails", JSON.stringify(guestDetails));

        if (
            companyDetails.RegistrationCompanyName ||
            companyDetails.RegistrationCompanyAddress ||
            companyDetails.RegistrationNumber
        ) {
            localStorage.setItem("companyDetails", JSON.stringify(companyDetails));
        }

        if (bookingComment.trim()) {
            localStorage.setItem("bookingComment", bookingComment);
        }

        alert("Data saved successfully!");
        navigate("/AgentRoomselect");
    };

    useEffect(() => {
        console.log("Guest Details:", JSON.parse(localStorage.getItem("guestDetails")));
        console.log("Company Details:", JSON.parse(localStorage.getItem("companyDetails")));
        console.log("Booking Comment:", localStorage.getItem("bookingComment"));
    }, []);

    return (
        <>
            <div className="wrapper">
                <AgentSidebar />
                <div className="main-panel">
                    <AgentHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">
                                                <h4>Add Guest Informations</h4>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="rounded-2 mt-3 p-3 position-relative" style={{ border: "1px solid rgb(189 181 181)" }}>
                                                    <h5 className="fw-bold position-absolute" style={{ top: "-14px", background: "#fff", paddingInline: "10px" }}>Guest Details</h5>
                                                    <div className="row">
                                                        <div className="col-md-2 mb-3">
                                                            <label className="form-label">Title</label>
                                                            <select name="Title" className="form-control form-select" value={guestDetails.Title} onChange={handleGuestChange} required>
                                                                <option value="">Select Title</option>
                                                                <option>Mr</option>
                                                                <option>Mrs</option>
                                                                <option>Ms</option>
                                                                <option>Miss</option>
                                                                <option>Dr</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">First Name</label>
                                                            <input type="text" name="FirstName" className="form-control" placeholder="Enter First Name" value={guestDetails.FirstName} onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">Middle Name</label>
                                                            <input type="text" name="MiddleName" className="form-control" placeholder="Enter Middle Name" value={guestDetails.MiddleName} onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">Last Name</label>
                                                            <input type="text" name="LastName" className="form-control" placeholder="Enter Last Name" value={guestDetails.LastName} onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Email</label>
                                                            <input type="email" name="EmailAddress" className="form-control" placeholder="Enter Email" value={guestDetails.EmailAddress} onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-5 mb-3">
                                                            <label className="form-label">Address</label>
                                                            <textarea name="Address" className="form-control" value={guestDetails.Address} placeholder="Enter Address" onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">Mobile Number</label>
                                                            <input type="number" name="MobileNumber" className="form-control" placeholder="Enter Mobile No" value={guestDetails.MobileNumber} onChange={handleGuestChange} required />
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">Country</label>
                                                            <select className="form-control form-select" onChange={handleCountryChange} value={selectedCountry} required>
                                                                <option value="">-- Select Country --</option>
                                                                {Country.getAllCountries().map((country) => (
                                                                    <option key={country.isoCode} value={country.isoCode}>
                                                                        {country.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-2 mb-3">
                                                            <label className="form-label">State</label>
                                                            <select className="form-control form-select" onChange={handleStateChange} value={selectedState} disabled={!states.length} required>
                                                                <option value="">Select State</option>
                                                                {states.map((state) => (
                                                                    <option key={state.isoCode} value={state.isoCode}>
                                                                        {state.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <label className="form-label">City</label>
                                                            <select className="form-control form-select" onChange={handleCityChange} value={guestDetails.City} disabled={!cities.length} required>
                                                                <option value="">Select City</option>
                                                                {cities.map((city, index) => (
                                                                    <option key={index} value={city.name}>
                                                                        {city.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="rounded-2 mt-4 p-3 position-relative" style={{ border: "1px solid rgb(189 181 181)" }}>
                                                    <h5 className="fw-bold position-absolute" style={{ top: "-14px", background: "#fff", paddingInline: "10px" }}>Company Details (Optional)</h5>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <label className="form-label">Registered Company Name</label>
                                                            <input type="text" name="RegistrationCompanyName" className="form-control" placeholder="Enter Company Name" value={companyDetails.RegistrationCompanyName} onChange={handleCompanyChange} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="form-label">Registered Company Address</label>
                                                            <textarea name="RegistrationCompanyAddress" className="form-control" placeholder="Enter Company Adderss" value={companyDetails.RegistrationCompanyAddress} onChange={handleCompanyChange} />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className="form-label">Registered Company Number</label>
                                                            <input type="number" name="RegistrationNumber" className="form-control" placeholder="Eneter Companny Number" value={companyDetails.RegistrationNumber} onChange={handleCompanyChange} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="rounded-2 mb-3 mt-4 p-3 position-relative" style={{ border: "1px solid rgb(189 181 181)" }}>
                                                    <h5 className="fw-bold position-absolute" style={{ top: "-14px", background: "#fff", paddingInline: "10px" }}>Booking Comment (Optional)</h5>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <textarea className="form-control" value={bookingComment} onChange={handleBookingCommentChange} placeholder="Enter Booking Comment" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="card-action text-end">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                </div>
                <ThemeSettings />
            </div>

        </>
    )
}
